export default (amount, isInCents) => {
  const multiplicand = isInCents ? 1 : 100;
  return Math.ceil(Number((amount * multiplicand).toFixed(2))) / multiplicand;
};
